import { Route, Routes } from "react-router-dom";

import AccountListOptionScreen from "screens/App/CRM/AccountListOption/AccountListOptionScreen";
import AccountListOptionDetailScreen from "screens/App/CRM/AccountListOption/AccountListOptionDetailScreen";
import { NotFoundScreen } from "screens/NotFoundScreen";

const AccountListRouter = () => {
  return (
    <Routes>
      <Route index element={<AccountListOptionScreen />} />
      <Route path="detail/:type" element={<AccountListOptionDetailScreen />} />
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default AccountListRouter;
